import { motion } from "framer-motion";

export default function SubScoreBar({ label, value, delay = 0 }) {
  return (
    <div className="flex flex-col gap-1.5" data-testid={`subscore-${label}`}>
      <div className="flex items-center justify-between">
        <span className="text-sm text-[#383633]">{label}</span>
        <span className="text-xs text-[#6F6B66] font-mono">{value}/100</span>
      </div>
      <div className="h-1 w-full bg-[#F3F3F3] rounded-full overflow-hidden">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${value}%` }}
          transition={{ duration: 1.1, delay, ease: [0.22, 1, 0.36, 1] }}
          className="h-full bg-[#D8C4A5] rounded-full"
        />
      </div>
    </div>
  );
}
